import {
  Box,
  Button,
  Image,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import'./SpecialChannel.component.css'

const SpecialChannel = () => {
  const SpecialChannelList = [
    {
      name: "JIFU",
      subName: "Mentorship",
      bg: "radial-gradient(50% 50% at 50% 50%, #601FEB 0%, #4B339A 100%)",
    },
    {
      name: "JIFU",
      subName: "Mentorship",
      bg: "radial-gradient(50% 50% at 50% 50%, #148DCF 0%, #005483 100%)",
    },
    {
      name: "JIFU",
      subName: "Mentorship",
      bg: "radial-gradient(50% 50% at 50% 50%, #8762EE 0%, rgba(73, 14, 242, 0.92) 100%)",
    },
  ];
  const productSpecial = SpecialChannelList.slice(0, 1);
  return (
    <VStack bg={"rgba(245, 245, 255, 1)"} py={"50px"}>
      {/* desktop-version */}
      <Box w="80%" m={"auto"} className="desktop-version">
        <Stack
          flexDir="row"
          justifyContent="space-between"
          alignItems={"center"}
        >
          <Box>
            <Text color="rgba(0, 0, 0, 1)" fontSize="36px" fontWeight={"700"}>
              Special Channel
            </Text>
          </Box>
          <Box>
            <Text
              color="rgba(0, 0, 0, 1)"
              fontSize="20px"
              fontWeight={"400"}
              cursor={"pointer"}
            >
              See all
            </Text>
          </Box>
        </Stack>

        <Stack w="100%" flexDir={"row"} py="25px">
          {SpecialChannelList.map((item) => (
            <Stack w="33.3%">
              <Box
                h="490px"
                borderRadius={"25px"}
                bg={item.bg}
                m="15px"
                position={"relative"}
                display="flex"
                alignItems={"flex-end"}
              >
                <Image src={Img.special} alt="special" w="100%" h={"auto"} />
                <Box
                  position={"absolute"}
                  top={"0"}
                  left={"0"}
                  right={"0"}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  flexDirection={"column"}
                  h="100%"
                >
                  <Text
                    fontSize="40px"
                    fontWeight={"900"}
                    fontFamily={"font-family: 'Poppins', sans-serif;"}
                    color="rgba(255, 255, 255, 1)"
                  >
                    {item.name}
                  </Text>
                  <Text
                    fontSize="40px"
                    fontWeight={"600"}
                    fontFamily={"font-family: 'Poppins', sans-serif;"}
                    color="rgba(255, 255, 255, 1)"
                  >
                    {item.subName}
                  </Text>
                  <UnorderedList listStyleType={"none"} display={"flex"} my="12px">
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif'r"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"16px"}
                      >
                        WED
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"16px"}
                      >
                        7p PST
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"16px"}
                      >
                        4p PST
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"16px"}
                      >
                        9p BST
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"16px"}
                      >
                        10p CET
                      </Text>
                    </ListItem>
                  </UnorderedList>
                  <Box>
                    <Button
                      borderRadius={"25px"}
                      type="button"
                      fontSize={"16px"}
                      fontWeight={"500"}
                      cursor={"pointer"}
                      border={"none"}
                      p="10px 25px"
                      color="rgba(0, 0, 0, 1)"
                      fontFamily={"'Poppins', sans-serif;"}
                      bg={"#fff"}
                    >
                      Click Here
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Box>
       {/* mobile-version */}
       <Box w="80%" m={"auto"} className="mobile-version">
        <Stack
          flexDir="row"
          justifyContent="space-between"
          alignItems={"center"}
        >
          <Box w="100%" textAlign='center'>
            <Text color="rgba(0, 0, 0, 1)" fontSize="24px" fontWeight={"600"}
            fontFamily="'Poppins',sans-serif"
            >
              Special Channel
            </Text>
          </Box>
        </Stack>

        <Stack w="100%" flexDir={"row"} py="25px">
          {productSpecial.map((item) => (
            <Stack w="100%">
              <Box
                h="335px"
                borderRadius={"25px"}
                bg={item.bg}
                position={"relative"}
                display="flex"
                alignItems={"flex-end"}
              >
                <Image src={Img.special} alt="special" w="100%" h={"auto"} />
                <Box
                  position={"absolute"}
                  top={"0"}
                  left={"0"}
                  right={"0"}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  flexDirection={"column"}
                  h="100%"
                >
                  <Text
                    fontSize="32px"
                    fontWeight={"900"}
                    fontFamily={"font-family: 'Poppins', sans-serif;"}
                    color="rgba(255, 255, 255, 1)"
                  >
                    {item.name}
                  </Text>
                  <Text
                    fontSize="24px"
                    fontWeight={"600"}
                    fontFamily={"font-family: 'Poppins', sans-serif;"}
                    color="rgba(255, 255, 255, 1)"
                  >
                    {item.subName}
                  </Text>
                  <UnorderedList listStyleType={"none"} display={"flex"} my="12px">
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif'r"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"14px"}
                      >
                        WED
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"14px"}
                      >
                        7p PST
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"14px"}
                      >
                        4p PST
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"14px"}
                      >
                        9p BST
                      </Text>
                    </ListItem>
                    <ListItem mx="5px">
                      <Text
                        fontFamily={"'Inter', sans-serif"}
                        fontWeight={"600"}
                        color={"rgba(255, 255, 255, 1)"}
                        fontSize={"14px"}
                      >
                        10p CET
                      </Text>
                    </ListItem>
                  </UnorderedList>
                  <Box>
                    <Button
                      borderRadius={"25px"}
                      type="button"
                      fontSize={"16px"}
                      fontWeight={"500"}
                      cursor={"pointer"}
                      border={"none"}
                      p="10px 25px"
                      color="rgba(0, 0, 0, 1)"
                      fontFamily={"'Poppins', sans-serif;"}
                      bg={"#fff"}
                    >
                      Click Here
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Box>
    </VStack>
  );
};

export default SpecialChannel;
